// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-7c865887] .object-details {\n  padding-left: 10px;\n  margin-left: 20px;\n  border-left: 3px solid #dee2e6;\n  margin-bottom: 1rem;\n}\n", ""]);
// Exports
module.exports = exports;
